import Vue from "vue";
import vuetify from "@/plugins/vuetify";
import VuetifyNotify from "@tt/vuetify-notify-plugin";

Vue.use(VuetifyNotify, { vuetify, target: ".v-main__wrap"});
